import { get } from '../../../api';
import { formatFullDate, formatFullDateEndOfMonth } from '../../../utils';

export default {
    getServices: baseUrl => get(`${baseUrl}/services`),
    // https://aibolit-qa2.epm-aimd.projects.epam.com/api/v2/public/booking/tomography-minsk/doctors/timeslots?branchId=5c0f8d15872be90a6&date=2023-01-26&serviceId=27
    getTimeslotsForServices: (baseUrl, date, serviceId, branchId) => get(`${baseUrl}/doctors/timeslots?branchId=${branchId}&date=${date}&serviceId=${serviceId}`),
    getDoctors: baseUrl => get(`${baseUrl}/doctors`),
    getBranches: baseUrl => get(`${baseUrl}/branches`),
    getAssignmentsInfo: (baseUrl, assignmentsIds) => get(`${baseUrl?.split?.('/')
        .slice(0, -1)
        .join('/')}/assignments?ids=${assignmentsIds.join(',')}`),
    getDoctorTimeTable: (baseUrl, assignmentId, dateStart, dateEnd) => get(
        `${baseUrl}/doctors/${assignmentId}/timeslots?dateStart=${
            dateStart || formatFullDate(Date.now())
        }&dateEnd=${dateEnd || formatFullDateEndOfMonth()}`,
    ),

};
